function initReCaptcha() {
  if (!window.jQuery) {
    // if init is triggered before jQuery is loaded, retry later
    return setTimeout(initReCaptcha, 100);
  } else if (document.readyState !== 'complete') {
    // if jQuery is loaded but document not ready, attach to event
    return $(initReCaptcha);
  }

  if (!window.grecaptcha) {
    console.error('Missing reCaptcha API!');
    return false;
  }

  $('.g-recaptcha').each(function (i, e) {
    initReCaptchaOnElement(e);
  });
}

window._Obis_Form_reCaptcha = {};
function initReCaptchaOnElement(elem) {
  if (_Obis_Form_reCaptcha.hasOwnProperty(elem.id)) {
    grecaptcha.reset(_Obis_Form_reCaptcha[elem.id]);
  }

  _Obis_Form_reCaptcha[elem.id] = grecaptcha.render(elem, {
    sitekey: $(elem).data('sitekey'),
    theme: $(elem).data('theme'),
    size: $(elem).data('size'),
    tabindex: $(elem).data('tabindex'),
    callback: function (token) {
      elem.previousElementSibling.value = token;
    }
  });
}